import React from "react";
import DateTimePicker from "../../../../../common/components/shared/dateTimePicker/dateTimePicker";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import {FerryDropDownModel} from "../../../../../dictionaries/models/ferry";
import {PortModel} from "../../../../../dictionaries/models/ports";
import {FerryService} from "../../../../../dictionaries/services/ferryService";
import {PortService} from "../../../../../dictionaries/services/portService";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import {DropDownUtils} from "../../../../../helpers/dropDownUtils";
import TransportUtils from "../../../../../helpers/transportUtils";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";

interface VoyageSectionState {
    ferries: FerryDropDownModel[];
    ports: PortModel[];
    ferriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    portsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class VoyageSection extends React.Component <any, VoyageSectionState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            ferries: [],
            ports: [],
            ferriesResponse: undefined,
            portsResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getFerries();
        await this.getPorts();
    }

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.voyage.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.order.details.voyage.properties.voyageNo")}
                            validatedValue={orderStore.voyageNo}
                            testId="voyage-no"
                            offAutocomplete
                        />
                        <DateTimePicker
                            label={i18n.t("transportation.order.details.voyage.properties.arrivalDepartureTime")}
                            validatedValue={orderStore.arrivalDepartureTime}
                            onChange={(newDate: Date | null) => {
                                if (newDate === null && orderStore.arrivalDepartureTime.value) {
                                    orderStore.setArrivalDepartureTime(orderStore.arrivalDepartureTime.value);
                                } else {
                                    orderStore.setArrivalDepartureTime(newDate);
                                }
                            }}
                            testId="arrival-departure-time"
                        />
                        <DropDown
                            className="element"
                            label={i18n.t("transportation.order.details.voyage.properties.ferryName")}
                            items={this.ferryToDropdown()}
                            validatedValue={orderStore.ferryId}
                            onChange={async (value) => {
                                await TransportUtils.setShipowner(this.state.ferries, orderStore, value);
                            }}
                            testId="ferry-name"
                            isLoader={this.state.ferries.length < 0}
                            error={!Api.isSuccess(this.state.ferriesResponse) ? i18n.t("errorMessages.ferriesErrorSuffix") : ""}
                            reloadFunc={() => this.getFerries()}
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.voyage.properties.shipownerName")}
                            validatedValue={orderStore.shipownerName}
                            testId="shipowner-name"
                            disabled
                            offAutocomplete
                        />
                        <DropDown
                            className="element"
                            label={i18n.t("transportation.order.details.voyage.properties.originDestinationPort")}
                            items={this.originDestinationPortToDropdown()}
                            validatedValue={orderStore.originDestinationPortId}
                            onChange={async (value) => {
                                await TransportUtils.setOriginDestinationCountry(this.state.ports, orderStore, value);
                            }}
                            testId="origin-destination-port"
                            isLoader={this.state.ports.length < 0}
                            error={!Api.isSuccess(this.state.portsResponse) ? i18n.t("errorMessages.portsErrorSuffix") : ""}
                            reloadFunc={() => this.getPorts()}
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.voyage.properties.originDestinationCountry")}
                            validatedValue={orderStore.originDestinationCountryName}
                            testId="origin-destination-country"
                            disabled
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.voyage.properties.bookingNo")}
                            validatedValue={orderStore.bookingNo}
                            testId="booking-no"
                            offAutocomplete
                        />
                    </Row>
                </div>
            </div>
        );
    }

    private ferryToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.ferries);
    }

    private originDestinationPortToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.ports, "id", "imoCode");
    }

    private async getFerries() {
        const orderStore = this.context.orderStore as IOrderStore;
        const ferriesResponse = await FerryService.getFerriesForDropDown();

        this.setState({
            ferries: (ferriesResponse)?.data || [],
            ferriesResponse,
        });

        await TransportUtils.setShipowner(this.state.ferries, orderStore, orderStore.ferryId.value);
    }

    private async getPorts() {
        const orderStore = this.context.orderStore as IOrderStore;

        const portsResponse = await PortService.getAll();
        this.setState({
            ports: (portsResponse)?.data?.data || [],
            portsResponse
        });

        await TransportUtils.setOriginDestinationCountry(this.state.ports, orderStore, orderStore.originDestinationPortId.value);
    }
}
